'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function TOFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-yj9bjc5sc", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-rsm48rbq4", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-5ajabpwml" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-5ajabpwml", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-yj9bjc5sc)" }, /* @__PURE__ */ React.createElement("use", { fill: "#e31d1c", xlinkHref: "#mantine-5ajabpwml" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 0h18v16H0z", mask: "url(#mantine-rsm48rbq4)" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M12 2v4h4v4h-4v4H8v-4H4V6h4V2z", mask: "url(#mantine-rsm48rbq4)" })))
  );
}

export { TOFlag };
//# sourceMappingURL=TO.mjs.map
